{
  "de": {
    "imagePicker": {
      "addButton": "Bild hinzufügen",
      "title": "Bild hinzufügen",
      "replaceTitle": "Bild ersetzen",
      "replaceButton": "Bild ersetzen",
      "backgroundPreviewAlt": "Aktuelles Hintergrundbild",
      "searchPlaceholder": "Bild suchen...",
      "tabLabelWithCount": "{label} ({count})",
      "resultCount": "Keine Ergebnisse | {count} Ergebnis | {count} Ergebnisse",
      "resultCountCapped": "Mehr als {count} Ergebnisse",
      "cancel": "Abbrechen",
      "confirm": "Verwenden",
      "empty": {
        "headline": "Hier gibt es keine Ergebnisse für „{query}“",
        "subline": "Probiere einen anderen Suchbegriff"
      },
      "error": {
        "headline": "Die Bilder konnten nicht geladen werden.",
        "retry": "Erneut versuchen"
      },
      "generate": {
        "tabLabel": "Bild generieren",
        "headline": "Erstelle ein Bild",
        "promptPlaceholder": "Beschreibe dein Bild",
        "cta": "Bild erstellen",
        "ctaRegenerate": "Bild neu erstellen",
        "generating": "Bild wird erstellt",
        "generated": "Bild erstellt und ausgewählt",
        "resultSelect": "Generiertes Bild auswählen",
        "modelLabel": "KI-Modell auswählen",
        "uploadError": "Das Bild konnte nicht übernommen werden. Bitte versuche es erneut.",
        "limitReached": "Du hast dein tägliches Limit für KI-Bilder erreicht."
      },
      "upload": {
        "tabLabel": "Upload",
        "dropTitle": "Per Drag & Drop hier reinziehen oder {select}.",
        "dropTitleSelect": "Bild auswählen",
        "success": "Datei erfolgreich hochgeladen",
        "remove": "Bild entfernen",
        "errors": {
          "wrongFormat": "Dieses Dateiformat wird nicht unterstützt. Erlaubte Formate: {formats}",
          "failed": "Das Bild konnte nicht hochgeladen werden. Bitte versuche es erneut."
        }
      },
      "stock": {
        "tabLabel": "Lizenzfreie Bilder",
        "source": "Quelle:",
        "imageTypeLegend": "Bildtyp",
        "categoryLimit": "Maximal {max} Kategorien gleichzeitig.",
        "uploadError": "Das Bild konnte nicht übernommen werden. Bitte versuche es erneut.",
        "categories": {
          "nature": "Natur",
          "animals": "Tiere",
          "research": "Forschung",
          "mathematics": "Mathematik",
          "technology": "Technik",
          "reading": "Lesen",
          "creativity": "Kreativität",
          "music": "Musik",
          "sports": "Sport",
          "nutrition": "Ernährung",
          "classroom": "Klassenzimmer",
          "teamwork": "Teamwork",
          "climate": "Klima",
          "space": "Weltraum",
          "summer": "Sommer",
          "spring": "Frühling",
          "autumn": "Herbst",
          "winter": "Winter",
          "easter": "Ostern",
          "christmas": "Weihnachten"
        }
      },
      "library": {
        "tabLabel": "Meine Ablage",
        "selectError": "Das Bild konnte nicht übernommen werden. Bitte versuche es erneut.",
        "imageAlt": {
          "manual": "Hochgeladenes Bild",
          "ai": "Mit KI erstelltes Bild"
        },
        "empty": {
          "headline": "Du hast noch keine Bilder",
          "subline": "Deine hochgeladenen und mit KI erstellten Bilder erscheinen hier."
        }
      }
    }
  }
}
